import { render, staticRenderFns } from "./TimeNotice.vue?vue&type=template&id=fcdb2328&scoped=true&"
import script from "./TimeNotice.vue?vue&type=script&lang=ts&"
export * from "./TimeNotice.vue?vue&type=script&lang=ts&"
import style0 from "./TimeNotice.vue?vue&type=style&index=0&id=fcdb2328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb2328",
  null
  
)

export default component.exports